import { higherCaseToCamelCase } from 'ClientService';

const filterCache = new WeakMap();

export const getServerSettings = state => {
  if (filterCache.has(state)) {
    return filterCache.get(state);
  }

  const settings = {};
  const source   = state?.persistStore?.settings;

  if (source) {
    for (const key in source) {
      settings[higherCaseToCamelCase(key)] = source[key];
    }
  }

  filterCache.set(state, settings);

  return settings;
};
